export class ReservationsDetailsForEventModelDTO {
  constructor (
    public venueId: string,
    public eventId: string,
    public pageSize: number = 10,
    public pageNumber: number = 1,

  ) {}
}
